// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__DHW5e","title":"Header_title__24UDJ","left":"Header_left__3BYwZ","clinicName":"Header_clinicName__2Mz9C"};